/**
 * Save data to local storage with key
 * @param {LocalStorageItem} item - The item to be stored in local storage.
 */
export const setLocalStorageItem = (key: string, value: any): void => {
  if (typeof Storage !== "undefined") {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
};

/**
 * Get data from local storage with key.
 * If data is not found, return null.
 * @param {string} key - The key of the item to be retrieved from local storage.
 * @returns {any} The item from local storage, or null if not found.
 */
export const getLocalStorageItem = (key: string): any => {
  if (typeof Storage !== "undefined") {
    const result = window.localStorage.getItem(key);

    if (result === "undefined") return null;

    if (result) {
      try {
        // If the data is JSON, parse it.
        return JSON.parse(result);
      } catch {
        // If the data is not JSON, return the raw value.
        return result;
      }
    }
  }
  return null;
};

/**
 * Remove data from local storage with key.
 * @param {string} key - The key of the item to be removed from local storage.
 */
export const removeLocalStorageItem = (key: string): void => {
  if (typeof Storage !== "undefined") {
    window.localStorage.removeItem(key);
  }
};
